module.exports = __webpack_public_path__ + "static/img/xy_41000030.fca86d98.png";